var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#C2B6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.16 11.359c.78-.034 1.334-.148 1.662-.343.329-.203.493-.478.493-.825 0-.296-.098-.52-.295-.673-.198-.16-.477-.24-.838-.24-.345 0-.67.071-.974.215a3.175 3.175 0 00-.874.66L9.2 8.871a4.445 4.445 0 011.27-.99c.492-.254 1.075-.381 1.749-.381.443 0 .846.06 1.207.178.37.11.686.279.949.507.263.22.464.496.603.826.148.33.222.706.222 1.13 0 .405-.066.757-.197 1.053a2.11 2.11 0 01-.517.736 2.562 2.562 0 01-.764.495 5.415 5.415 0 01-.949.28l-.135.774H11.38l-.284-2.057.062-.063zm1.81 5.141h-1.996v-2.031h1.996V16.5z",
    fill: "#6244FF"
  })));
}

export default SvgFaq;